export class IncidentNoteDTO {
  id: string;
  message: string;
  date: Date;
  taskId: number;
  readStatus: boolean;
}